import RegisterService from 'services/RegisterService';

export default checkAvailability(new RegisterService());

export function checkAvailability(service) {
  return name => async () => {
    const { data } = await service.checkAvailability(name);
    return data;
  };
}